import * as Icons from "lucide-react";

// Renders a lucide-react icon by string name, with a safe fallback.
export const Icon = ({ name, className = "h-6 w-6", ...rest }) => {
  const Cmp = Icons[name] || Icons.Circle;
  return <Cmp className={className} {...rest} />;
};
